var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({ width: _vm.width, height: _vm.height }),attrs:{"id":_vm.classId}})
}
var staticRenderFns = []

export { render, staticRenderFns }